import { useState } from 'react';

const useToggleShowPassword = (fillColor) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => setShowPassword(!showPassword);
  const inputIcon = showPassword ? 'Eye' : 'EyeCrossed';

  return {
    iconProps: {
      icon: inputIcon,
      onClick: toggleShowPassword,
      ...(!!fillColor && { fillColor }),
    },
    inputIcon,
    showPassword,
    toggleShowPassword,
  };
};

export default useToggleShowPassword;
